import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Header({ isDownloadPressed, setIsDownloadPressed }) {
    const { logout, phone } = useAuth();

    return (
        <header className="flex items-center justify-between py-5 px-4 max-w-md mx-auto lg:max-w-4xl">
            <div className="text-lg md:text-xl font-bold text-primary">
                Ananas Calorie Tracker
            </div>

            <div className="flex items-center gap-4">
                {phone && (
                    <div
                        onClick={logout}
                        className="px-4 py-2 md:px-6 rounded-2xl text-sm md:text-base font-medium transition-colors flex items-center justify-center gap-2 bg-inherit text-white hover:bg-primary border border-primary cursor-pointer duration-300"
                    >
                        <span className="text-sm">{phone}</span>
                        <button className="text-sm">خروج</button>
                    </div>
                )}

                <button
                    onClick={() => setIsDownloadPressed(!isDownloadPressed)}
                    className={`px-4 py-2 md:px-6 rounded-2xl text-sm md:text-base bg-primary font-medium transition-colors flex items-center justify-center ${isDownloadPressed
                            ? "bg-[#AE3A3C] text-white hover:bg-[#9A3235]"
                            : "bg-app-coral text-black hover:bg-app-coral-hover"
                        }`}
                >
                    Download
                </button>
            </div>
        </header>
    );
}
